import React, { Fragment, Component } from 'react';
import
{
    Nav, NavItem, NavLink, TabContent, TabPane, Button, ListGroup, ListGroupItem
} from 'reactstrap';
import classnames from 'classnames';
import { Chat } from '@progress/kendo-react-conversational-ui';
import * as LiveChatUtils from '../PlayerUI/js/live_chat';
export default class RightPart extends Component
{
    constructor(props)
    {
        super(props);
        this.bot = { id: 0 };
        this.state = {
            chat_messages: [],
            user: {
                id: 1,
                avatarUrl: "https://via.placeholder.com/24/008000/008000.png"
            },
            
        }
    }
    toggle = (tab) =>
    {
        this.props.toggle(tab);
    }
    closeShowPdf = () =>
    {
        this.props.closeShowPdf();
    }
    onClickRefUrl = (url) =>
    {
        this.props.onClickRefUrl(url);
    }
    onBookmarkClick = (time) =>
    {
        this.props.onBookmarkClick(time);
    }
    loadChat = () =>
    {
        LiveChatUtils.load_chat(this);
    }
    MessageTemplate(props)
    {
        return (
            <div className="k-bubble">
                <div> {props.item.text}</div>
            </div>
        );
    }
    addNewMessage = (event) =>
    {
        let botResponce = Object.assign({}, event.message);
        botResponce.text = this.countReplayLength(event.message.text);
        botResponce.author = this.bot;
        this.setState((prevState) => ({
            messages: [
                ...prevState.messages,
                event.message
            ]
        }));
        setTimeout(() =>
        {
            this.setState(prevState => ({
                messages: [
                    ...prevState.messages,
                    botResponce
                ]
            }));
        }, 1000);
    };
    countReplayLength = (question) =>
    {
        let length = question.length;
        let answer = question + " contains exactly " + length + " symbols.";
        return answer;
    }
    loadChat = () =>
    {
        LiveChatUtils.load_chat(this);
    }
    render()
    {
        return <div className="pane-content" style={this.props.videoData.is_dark === true ? { backgroundColor: "#1f1f1f", height: "inherit", color: "white", borderBottom: "solid 1px white" } : null}>
            <Nav tabs="true">
                {this.props.videoData.videoType === "2" && this.props.videoData.show_chat === true ? < NavItem >
                    <NavLink href="javascript:void(0);"
                        className={classnames({ active: this.props.activeTab === '1', darkNav: this.props.videoData.is_dark === true && this.props.activeTab === '1' })}
                        onClick={() =>
                        {
                            this.toggle('1');
                        }}
                        style={this.props.videoData.is_dark === true ? { color: "white" } : null}
                    >
                        Chat
                                                </NavLink>
                </NavItem>
                    : null}
                {this.props.videoData.show_references === true ? < NavItem >
                    <NavLink href="javascript:void(0);"
                        className={classnames({ active: this.props.activeTab === '2', darkNav: this.props.videoData.is_dark === true && this.props.activeTab === '2' })}
                        onClick={() =>
                        {
                            this.toggle('2');
                        }}
                        style={this.props.videoData.is_dark === true ? { color: "white" } : null}>
                        References
                                                </NavLink>
                </NavItem> : null}
                {this.props.videoData.videoType === "1" && this.props.videoData.show_bookmarks === true ? <NavItem>
                    <NavLink href="javascript:void(0);"
                        className={classnames({ active: this.props.activeTab === '3', darkNav: this.props.videoData.is_dark === true && this.props.activeTab === '3' })}
                        onClick={() =>
                        {
                            this.toggle('3');
                        }}
                        style={this.props.videoData.is_dark === true ? { color: "white", backgroundColor: "#1f1f1f" } : null}>
                        Bookmarks
                                                </NavLink>
                </NavItem> : null}

            </Nav>
            <TabContent activeTab={this.props.activeTab}>
                <TabPane tabId="1">
                    <Chat user={this.props.chat_user_info}
                        className="k-chat2"
                        messages={this.state.chat_messages}
                        width="95%"
                        onMessageSend={(e) => { LiveChatUtils.add_new_chat(this,e) }}
                        messageTemplate={this.MessageTemplate}>
                    </Chat>
                </TabPane>
                <TabPane tabId="2">{
                    this.props.divShowPdf === true ? <Fragment>
                        <Button onClick={this.closeShowPdf} color="primary" >Back</Button>
                        <br /><br />
                        <iframe src={this.props.pdfUrl} style={{ width: "100%", height: "680px" }} ref={i => { this.iframPdf = i; }} />
                    </Fragment> :

                        <ListGroup flush>
                            {this.props.videoData.video_references.length === 0 ?
                                <label>There are no refeneces in this video</label> : null}
                            {this.props.videoData.video_references.map((item, index) =>
                            {
                                return <ListGroupItem className="pt-2 pb-2 pr-2" style={this.props.videoData.is_dark === true ? { backgroundColor: "#1f1f1f" } : {}}>
                                    <Button style={this.props.videoData.is_dark === true ? { color:"white" } : {}} color="link" onClick={() => { this.onClickRefUrl(item.reference_url) }}>{index + 1}.{item.reference_title}</Button>
                                </ListGroupItem>
                            })
                            }
                        </ListGroup>
                }
                </TabPane>
                <TabPane tabId="3">
                    <ListGroup flush>
                        {this.props.videoData.video_bookmarks.length === 0 ?
                            <label>There are no bookmarks in this video</label> : null}
                        {this.props.videoData.video_bookmarks.map((item, index) =>
                        {
                            return <ListGroupItem className="pt-2 pb-2 pr-2" style={this.props.videoData.is_dark === true ? { backgroundColor: "#1f1f1f" } : {}}>
                                <Button style={this.props.videoData.is_dark === true ? { color: "white" } : {}} onClick={() => { this.onBookmarkClick(item.bookmark_second) }} color="link" >{index + 1}.{item.bookmark_title}</Button>
                            </ListGroupItem>
                        })
                        }
                    </ListGroup>
                </TabPane>
            </TabContent>

        </div>
    }
}